<script>
	import Layout from "../../layouts/main"
	import PageHeader from "@/components/page-header"
	import appConfig from "@/app.config"
	import Multiselect from "vue-multiselect"
	import DatePicker from "vue2-datepicker"
	import AWS  from 'aws-sdk'

	export default {
		middleware: "authentication",
		page: {
			title: "",
			meta: [
				{
					name: "description",
					content: appConfig.description,
				},
			],
		},
		components: {
			Layout,
			PageHeader,
			Multiselect,
			DatePicker,
		},
		data: function() {
			return {
				items: [
					{
						text: "View",
					},
					{
						text: "Attendance",
						active: true,
					},
				],
				isReportTableBusy: false,
				excelDownloading: false,
				totalRows: 1,
				currentPage: 1,
				perPage: 10,
				pageOptions: [10, 25, 50, 100, 500],
				tableData: [],
				moment: this.$moment,
				employeeFilterBranch: [],
				selectedBranch: null,
				sortBy: "updatedAt",
				sortDesc: true,
				filter: '',
				corporateId: '',
				reimbursementStatus: '',
				fields: [
					{
						key: 'actions',
						label: 'Actions',
						tdClass: 'align-center align-middle',
						sortable: false,
						thStyle: { backgroundColor: '#f6f6f6' },
					},
					{
						key: 'employeeDetail[0].name',
						label: 'Employee Name',
						tdClass: 'align-center align-middle',
						sortable: true,
						thStyle: { backgroundColor: '#f6f6f6' },
					},
					{
						key: 'employeeDetail[0].designation',
						label: 'Designation',
						tdClass: 'align-center align-middle',
						sortable: true,
						thStyle: { backgroundColor: '#f6f6f6' },
					},
					// {
					// 	key: 'month',
					// 	label: 'Month',
					// 	tdClass: 'align-center align-middle',
					// 	sortable: true,
					// 	thStyle: { backgroundColor: '#f6f6f6' },
					// },
					{
						key: 'totalExpenseAmount',
						label: 'Toal Expense Amount',
						tdClass: 'align-center align-middle',
						sortable: true,
						thStyle: { backgroundColor: '#f6f6f6' },
					},
					{
						key: 'lastExpenseDate',
						label: 'Last Expense Date',
						tdClass: 'align-center align-middle',
						sortable: true,
						thStyle: { backgroundColor: '#f6f6f6' },
					},
				],
				daterange: [
					new Date(new Date().setDate(new Date().getDate() - 30)),
					new Date()
				],
				reimbursementFilterOptions: [
					'Pending',
					'Approved',
					'Denied',
				],
				fileUrl: '',
				expencesId: '',
				reason: '',
				searchQuery: '',
			}
		},
		computed: {
			rows: function() {
				return this.totalRows
			},
		},
		mounted: function() {
			this.corporateId = sessionStorage.getItem('corporateId')
			this.getBranchList()
		},
		methods: {
			getBranchList: function() {
				this.$api.post('corporate/get-branch', {
					corporateId: (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId,
				}).then(response => {
					this.employeeFilterBranch = response.data.data
					this.selectedBranch = this.employeeFilterBranch[0]
					this.getReimbursementList()
				}).catch(error => {
					console.log(error)
				})
			},
			getColor(status) {
				if (status === 'approved') return "badge badge-pill bg-soft-success font-size-13 bg-soft-success"
				if (status === 'pending') return "badge badge-pill bg-soft-success font-size-13 bg-soft-warning"
				return "badge badge-pill bg-soft-success font-size-13 bg-soft-danger";
			},
			getReimbursementList: function() {
				this.$api.post('employee-expense/list', {
					corporateId: (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId,
					branchId: this.selectedBranch._id,
					page: this.currentPage,
					pageSize: this.perPage,
					approvalStatus: this.reimbursementStatus,
					searchKeyword: this.searchQuery,
					startDate: this.moment(this.daterange[0]).format('YYYY-MM-DD HH:mm:ss'),
					endDate: this.moment(this.daterange[1]).format('YYYY-MM-DD HH:mm:ss'),
				}).then(response => {
					console.log(response.data)
					this.tableData = response.data.data.listing
					this.totalRows = response.data.data.totalCounts
				}).catch(error => {
					console.log(error)
				})
			},
			approveExpences: function(id) {
				this.$api.post('employee-expense/approve', {
					employeeExpenseId: id,
				}).then(response => {
					console.log(response.data)
					let statusCode = response.data.responseCode
					if (statusCode === 200) {
						var index = this.tableData.findIndex((expense) => {
							return expense._id == id
						})
						this.expencesId = ''
						this.tableData[index].approvalStatus = 'approved'
					}
					if (statusCode === 400) {
						this.$toast.error(response.data.response, {
							position: "top-right",
							timeout: 5000,
							closeOnClick: true,
							pauseOnFocusLoss: true,
							pauseOnHover: true,
							draggable: true,
							draggablePercent: 0.6,
							showCloseButtonOnHover: false,
							hideProgressBar: false,
							closeButton: "button",
							icon: true,
							rtl: false
						})
					}
				}).catch(error => {
					console.log(error)
				})
			},
			updateStatus: function() {
				this.$api.post('employee-expense/deny', {
					employeeExpenseId: this.expencesId,
					approvalReason: this.reason,
				}).then(response => {
					console.log(response.data)
					let statusCode = response.data.responseCode
					if (statusCode === 200) {
						var index = this.tableData.findIndex((expense) => {
							return expense._id == this.expencesId
						})
						this.reason = ''
						this.expencesId = ''
						this.tableData[index].approvalStatus = 'denied'
						this.$refs.rejectExpenses.hide()
					}
				}).catch(error => {
					console.log(error)
				})
			},
			openRejectPopup: function (id) {
				this.expencesId = id;
				console.log(this.expencesId)
				this.$refs.rejectExpenses.show()
			},
			changePageSize: function(value) {
				this.perPage = value
				this.getReimbursementList()
			},
			changePage: function(value) {
				this.currentPage = value
				this.getReimbursementList()
			},
			getFileUrl: function(fileName) {
				let name = fileName.substring(fileName.lastIndexOf('/') + 1)
				const s3Object = new AWS.S3({
					region: this.$region,
					credentials: {
						accessKeyId: this.$accessKeyId,
						secretAccessKey: this.$secretAccessKey,
					},
				})
				let url = s3Object.getSignedUrl('getObject', {
					Bucket: this.$bucket,
					Key: name,
					//Key: '0s4xNjupkOXcPmQKBdVJRlvJKafPBf8YLhtIBt0A.pdf'
				})
				return url
			},
			openPopup: function(fileName) {
				this.$refs.viewFiles.show()
				this.fileUrl = this.getFileUrl(fileName)
			},
			applyFilter: function() {
				this.getReimbursementList()
			},
			clearFilter: function() {
				this.selectedBranch = this.employeeFilterBranch[0]
				this.getReimbursementList()
			},
			searchFilter: function(value) {
				this.searchQuery = value
				this.getReimbursementList()
			},
			viewSheet: function(id) {
				console.log(id)
			},
			addNameToStorage: function(item) {
				sessionStorage.setItem("employeeName", item.employeeDetail[0].name)
				console.log(item.employeeDetail[0].name)
			}
		},
	}
</script>
<style>
	textarea {
		resize: none;
	}
	.view-link {
		font-size: 22px;
	}
</style>
<template>
	<Layout>
		<PageHeader :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card mb-4 filter-card">
					<div class="card-body">
						<div class="row inner">
							<div class="col-md-2" style="width: 20%">
								<label>Date Range </label>
								<date-picker v-model="daterange" format="DD MMM Y" append-to-body range lang="en"></date-picker>
							</div>
							<!-- <div class="col-md-2" style="width: 18%;">
								<label>Select </label>
								<multiselect v-model="reimbursementStatus" :options="reimbursementFilterOptions" :show-labels="false" />
							</div> -->
							<div class="col-md-4">
								<label for="branch">Select Branch</label>
								<multiselect id="branch" v-model="selectedBranch" :options="employeeFilterBranch" placeholder="Select Branch" :multiple="false" track-by="name" label="name" :allow-empty="false">
									<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
								</multiselect>
							</div>
							<div class="col-md-2" style="width: auto;">
								<button class="btn btn-outline-primary mt-4" v-on:click="applyFilter()">Apply Filter</button>
							</div>
							<div class="col-md-2" style="width: auto;">
								<button class="btn btn-outline-danger mt-4" v-on:click="clearFilter()">Clear Filter</button>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div class="row mb-4">
							<div class="col-sm-12 col-md-4">
								<!-- <div class="btn-group" role="group">
									<button class="btn btn-outline-primary" type="button">
										<span>Download Report</span>
										<b-spinner v-if="excelDownloading" small type="grow"></b-spinner>
										<b v-if="excelDownloading">Loading...</b>
									</button>
								</div> -->
							</div>
							<div class="col-sm-12 col-md-4">
								<div id="tickets-table_length" class="dataTables_length">
									<label class="d-inline-flex align-items-center">
										<span>Show</span>
										<b-form-select style="margin-left:5px; margin-right:5px" v-model="perPage" size="sm" :options="pageOptions" @change="changePageSize"></b-form-select>
										<span>entries</span>
									</label>
								</div>
							</div>
							<div class="col-sm-12 col-md-4">
								<div id="tickets-table_filter" class="dataTables_filter text-md-end">
									<label class="d-inline-flex align-items-center">
										<span>Search:</span>
										<b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2" @keyup="searchFilter(filter)"></b-form-input>
									</label>
								</div>
							</div>
						</div>
						<div class="table-responsive mb-0">
							<b-table striped hover outlined bordered :items="tableData" :fields="fields"
								thead-class="bg-transparent" responsive="sm" :per-page="0"
								:current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
								fixed-header :busy="isReportTableBusy" show-empty>
								<template #table-busy>
									<div class="text-center text-danger my-2">
										<b-spinner variant="primary" class="align-middle" type="grow"></b-spinner>
										<strong class="text-primary">Loading...</strong>
									</div>
								</template>
								<template v-slot:cell(lastExpenseDate)="{ item }">{{ moment(item.lastExpenseDate).format('YYYY-MM-DD') }}</template>
								<template v-slot:cell(totalExpenseAmount)="{ item }">
									<div v-if="item.totalExpenseAmount != null">
										<i class="mdi mdi-currency-rupee"></i>
										<span>{{ item.totalExpenseAmount.$numberDecimal }}</span>
									</div>
								</template>
								<template v-slot:cell(actions)="{ item }">
									<router-link class="view-link" :to="{
										name: 'view-reimbursement',
										params: {
											employeeId: item._id,
											employeeName: ((item.employeeDetail.length > 0) ? item.employeeDetail[0].name : ''),
										},
									}">
										<i class="mdi mdi-eye"></i>
									</router-link>
								</template>
							</b-table>
						</div>
						<div class="row">
							<div class="col">
								<div class="dataTables_paginate paging_simple_numbers float-end">
									<ul class="pagination pagination-rounded mb-0">
										<b-pagination
											v-model="currentPage"
											:total-rows="rows"
											:per-page="perPage"
											@change="changePage" />
									</ul>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<b-modal centered ref="viewFiles" class="view" hide-footer size="lg" hide-title title="">
			<div class="d-flex justyfy-content-center">
				<embed :src="fileUrl" width="100%" />
			</div>
		</b-modal>
		<b-modal centered ref="rejectExpenses" id="reject" class="modal fade" title="Reject Expences">
			<div class="d-flex flex-column">
				<label for="reason">Reason</label>
				<textarea id="reason" class="form-control" v-model="reason" placeholder="Enter a reason"></textarea>
			</div>
			<template #modal-footer="{cancel}">
				<button class="btn btn-secondary" @click="cancel()">Close</button>
				<button class="btn btn-primary" @click="updateStatus()">Update</button>
			</template>
		</b-modal>
	</Layout>
</template>